var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "fitting center" },
    [
      _c(
        "collapsible",
        {
          attrs: {
            step: 1,
            label: `Band size: <b>${_vm.underbust_size}"</b>`,
            has_next: true,
            max_height: 1080,
          },
        },
        [_c("step_1")],
        1
      ),
      _vm._v(" "),
      _c(
        "collapsible",
        {
          attrs: {
            step: 2,
            label: `Cup size: <b>${_vm.cup_size}"</b>`,
            has_next: true,
            max_height: 1080,
          },
        },
        [_c("step_2")],
        1
      ),
      _vm._v(" "),
      _c(
        "collapsible",
        {
          attrs: {
            step: 3,
            label: `Shape: <b>${_vm.shapeToDisplayName(_vm.shape)}</b>`,
            max_height: 2500,
          },
        },
        [_c("step_3")],
        1
      ),
      _vm._v(" "),
      _c(
        "collapsible",
        {
          attrs: {
            step: 4,
            label: `Waist: <b>${
              _vm.skipped_bottoms ? "skipped" : _vm.waist_size
            }</b> Hip: <b>${
              _vm.skipped_bottoms ? "skipped" : _vm.hip_size
            }</b>`,
            has_next: true,
            max_height: 3000,
          },
        },
        [_c("step_4")],
        1
      ),
      _vm._v(" "),
      _vm.underbust_size && _vm.cup_size && _vm.shape
        ? _c(
            "collapsible",
            { attrs: { step: 5, "max-height": 9999 } },
            [
              _c("step_5", { attrs: { online_fitting: _vm.online_fitting } }),
              _vm._v(" "),
              _vm.fittings ? _c("results") : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.step == 1
        ? _c("div", { staticClass: "form-group" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-danger btn-restart",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.reset.apply(null, arguments)
                  },
                },
              },
              [_vm._v("\n      Start over?\n    ")]
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }